export default "__VITE_ASSET__BMxSfcbh__"